import { PolicyDetailsV2 } from "@hagerty/customer-insurance-gateway-client";

import { getFormattedDate } from "../../utils/getFormattedDate";

type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

type PartialPolicyDetailsV2 = Omit<Optional<PolicyDetailsV2, "effectiveDate" | "expirationDate" | "paperlessDetails">, "policyNumber">;

export function createPoliciesMap<T extends string>(obj: Record<T, PartialPolicyDetailsV2>) {
  const objWithId = Object.entries<PartialPolicyDetailsV2>(obj).map(([key, value]) => [
    key,
    {
      policyNumber: key,
      effectiveDate: getFormattedDate({ months: -8 }),
      expirationDate: getFormattedDate({ months: 4 }),
      ...value,
    },
  ]);

  return Object.fromEntries(objWithId) as Record<T, PolicyDetailsV2>;
}
